
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { formatDistanceToNow } from "date-fns";
import { ChatPreview } from "./types";
import { Users } from "lucide-react";

type ChatPreviewItemProps = {
  chat: ChatPreview;
  selected: boolean;
  onSelect: () => void;
};

const ChatPreviewItem = ({ chat, selected, onSelect }: ChatPreviewItemProps) => {
  const timestamp = typeof chat.timestamp === 'string' 
    ? new Date(chat.timestamp) 
    : chat.timestamp;
  
  const isGroup = chat.type === 'group';
  const displayName = isGroup ? chat.groupName : chat.user.name;
  
  return (
    <div
      className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${
        selected ? "bg-primary/10" : "hover:bg-muted/80"
      } ${chat.unread ? "font-medium" : ""}`}
      onClick={onSelect}
    >
      <Avatar className="h-12 w-12 border border-border">
        {isGroup ? (
          <>
            <div className="bg-primary/10 h-full w-full flex items-center justify-center">
              <Users className="h-5 w-5 text-primary" />
            </div>
            <AvatarFallback>{chat.groupName?.slice(0, 2).toUpperCase() || "GC"}</AvatarFallback>
          </>
        ) : (
          <>
            <AvatarImage src={chat.user.avatarUrl} />
            <AvatarFallback>{chat.user.name.slice(0, 2).toUpperCase()}</AvatarFallback>
          </>
        )}
      </Avatar>
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-center">
          <p className="font-medium truncate">{displayName}</p>
          <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
            {formatDistanceToNow(timestamp, { addSuffix: true })}
          </span>
        </div>
        <p className={`text-sm truncate ${chat.unread ? "text-foreground" : "text-muted-foreground"}`}>
          {chat.lastMessage}
        </p>
      </div>
      {chat.unread && (
        <div className="h-2.5 w-2.5 rounded-full bg-primary flex-shrink-0"></div>
      )}
    </div>
  );
};

export default ChatPreviewItem;
